import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.primary.main,
    zIndex: 1,
    '&:hover':{
      color: theme.palette.secondary.main
    }
  },
}));

const Video = ({ onClose }) => {
  const classes = useStyles();

  return (
    <Dialog open fullWidth maxWidth={'lg'} onBackdropClick={onClose}>
      <div className="video-wrapper">
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <video
          autoPlay
          width="100%"
          height="auto"
          controls
          src="https://weadmit-static.s3.us-east-2.amazonaws.com/Solo+Parent+Onboarding+Video.mp4"
        />
      </div>
    </Dialog>
  );
};

export default Video;
